<template>
  <div class="app-tutorial flex w-full" :style="{ backgroundImage: `url(${tutorialHomeBg})` }">
    <CommonDocumentMenu
      :catalog="tutorialMenu"
      :prefix-path="`/${$route.params.lang}/tutorial/${$route.params.category}`"
    />
    <section class="app-tutorial-inner">
      <NuxtPage v-if="tutorialMenu.length" />
    </section>
  </div>
</template>
<script lang="ts" setup>
import bg from '@/assets/images/docs_bg.jpg'
useRouteCache((route) => {
  route.setCacheable().setMaxAge(300).addTags(['docs-index-page-cache-tag'])
})
const route = useRoute()
const documentStore = useDocumentStore()
const { fetchTutorialCategory, updateActivePath } = documentStore
const { tutorialMenu, tutorialHomeList } = storeToRefs(documentStore)
const tutorialHomeBg = ref(bg)
await fetchTutorialCategory(route.params.category === 'fe' ? '1' : '0')
function updateHomePage() {
  tutorialHomeBg.value = tutorialHomeList.value[String(route.params.id)]?.cover_img || bg
}
watchEffect(() => updateActivePath(tutorialMenu.value, 'url', String(route.params.id)))
watchEffect(() => updateHomePage())

watch(
  () => route.params.category,
  async (value) => {
    await fetchTutorialCategory(value === 'fe' ? '1' : '0')
  }
)
</script>
<style lang="scss" scoped>
.app-tutorial {
  //background-image: url('@/assets/images/docs_bg.jpg');
  background-position: center top;
  background-repeat: repeat-y;
}
.app-tutorial-inner {
  @apply 2xl:max-w-[calc(100%-380px)] max-2xl:max-w-[calc(100%-352px)] flex-1 pt-3 max-lg:w-full max-lg:max-w-full max-lg:pr-0  max-2xl:pr-5 lg:pt-6;
  @apply rtl:2xl:pl-15 ltr:2xl:pr-15;
}
</style>
